import { AppStreamEnvironment } from '../models/AppStreamEnvironment';

export class GetAppStreamEnvironmentResponse {
  appStreamEnvironment?: AppStreamEnvironment;
}
